module.exports = __webpack_public_path__ + "static/media/icon_53.2cdd7d89.svg";